export default __webpack_public_path__ + "static/media/mobile_containts-46.87023d12.png";